import moment from 'moment';

export function getMeses() {
    return [
        { value: "01", name: "Enero", disabled: true },
        { value: "02", name: "Febrero" },
        { value: "03", name: "Marzo" },
        { value: "04", name: "Abril" },
        { value: "05", name: "Mayo" },
        { value: "06", name: "Junio" },
        { value: "07", name: "Julio" },
        { value: "08", name: "Agosto" },
        { value: "09", name: "Septiembre" },
        { value: "10", name: "Octubre" },
        { value: "11", name: "Noviembre", selected: true },
        { value: "12", name: "Diciembre" },
    ];
}

export function getMesDias(anio,mes) {

    let diasMes = new Date(anio, mes, 0).getDate();
    let diasSemana = ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"];

    let data = []
    for (var dia = 1; dia <= diasMes; dia++) {
        // Ojo, hay que restarle 1 para obtener el mes correcto
        let indice = new Date(anio, mes - 1, dia).getDay();
        console.log(`El día número ${dia} del mes ${mes} del año ${anio} es ${diasSemana[indice]}`);
        data.push({ num_dia: dia.toString().padStart(2,'0'), name: diasSemana[indice] }) 
    }

    return data;

}

export const nullToString = (string) => {
    return string == null ? '' : string;
}

export const stringToDate = (fecha) => {
    if(fecha==null){
        return '';
    }else{
        let fecha_nueva = new Date(fecha);
        fecha_nueva.setMinutes(fecha_nueva.getMinutes() + fecha_nueva.getTimezoneOffset());
        return fecha_nueva; //new Date(data.alumno.fecha_nacimiento).toUTCString()
    }
}

export const dateToString = (fecha) => {
    if( fecha==null || fecha.toString()=='' ){
        return ''
    }else{
        return moment(fecha).format("YYYY-MM-DD")
    }
}

export const dateToStringHHmm = (fecha) => {
    if( fecha==null || fecha.toString()=='' ){
        return ''
    }else{
        return moment.utc(fecha).format("HH:mm")
    }
}

export const dateHHmmToStringDateHHmm = (fecha) => {
    if( fecha==null || fecha.toString()=='' ){
        return ''
    }else{
        return moment.utc(fecha).format("DD/MM/YYYY HH:mm")
    }
}

export const dateHHmmToHHmm = (fecha) => {
    if( fecha==null || fecha.toString()=='' ){
        return ''
    }else{
        const timeOnly = fecha.substring(11, 16);
        const horaMoment = moment(timeOnly, 'HH:mm');
        return horaMoment._d
    }
}

export const isObject = (objeto) => {
    if (typeof objeto === 'object' && objeto !== null && Object.keys(objeto).length > 0) {
        return true
    } else {
        return false
    }
}
